// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Qj6a","badges":"styles_badges__j795Y"};